import { useState } from "react";
import { useCircularArray } from "../../hooks/useCircularArray";
import { BodyPartPickerSide, BodyPartPickerGender } from "../types";
export const useBodyParts = ({ defaultSide, defaultGender, bodyParts }) => {
    const [selectedBodyParts, setSelectedBodyParts] = useState(bodyParts);
    const { currentValue: side, nextValue: nextSideValue, next: nextSide, setCurrentValueByValue: setSide, } = useCircularArray(Object.values(BodyPartPickerSide), defaultSide);
    const { currentValue: gender, setCurrentValueByValue: setGender, next: nextGender, nextValue: nextGenderValue, } = useCircularArray(Object.values(BodyPartPickerGender), defaultGender);
    const handleBodyPartClick = (event) => {
        const clickedBodyPartId = event.target.id;
        if (!clickedBodyPartId)
            return selectedBodyParts;
        if (selectedBodyParts.includes(clickedBodyPartId)) {
            const newParts = selectedBodyParts.filter((bodyPartId) => bodyPartId !== clickedBodyPartId);
            setSelectedBodyParts(newParts);
            return newParts;
        }
        else {
            const newParts = [...selectedBodyParts, clickedBodyPartId];
            setSelectedBodyParts(newParts);
            return newParts;
        }
    };
    const clearParts = () => {
        setSelectedBodyParts([]);
    };
    const switchToMale = () => {
        return setGender(BodyPartPickerGender.Male);
    };
    const switchToFemale = () => {
        return setGender(BodyPartPickerGender.Female);
    };
    const switchGender = () => {
        return nextGender();
    };
    const switchSide = () => {
        return nextSide();
    };
    return {
        side,
        nextSideValue,
        gender,
        nextGenderValue,
        selectedBodyParts,
        handleBodyPartClick,
        clearParts,
        switchGender,
        switchToMale,
        switchToFemale,
        setSide,
        switchSide,
        setGender,
    };
};
//# sourceMappingURL=useBodyParts.js.map